<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="6" width="8" height="8" rx="1" />
    <rect x="3" y="4" width="10" height="2" rx="1" />
    <rect x="6" y="2" width="4" height="2" rx="1" />
    <path d="M6 8L6 12" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 8L8 12" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 8L10 12" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
